import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { UtilitiesService } from 'src/app/core/utilities.service';
import {DataService} from "../../data.service";
import { environment } from '../../../environments/environment';

declare const $: any;
@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.scss'],
})
export class ProductEditComponent implements OnInit {
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;

  // Basic states
  storeId;
  bearer;
  languageCode;
  countryCode;
  productId: Number;
  productName: any = '';
  featureList;

  // Form states
  editMixtureProductId?: Number = null;
  currentProductMixtureName = '';

  // Media Editor variables for product photo
  mediaPhotoId;
  imgURL_Primary;
  imgURL_UploadImg = [];
  imgURLs = [];

  // Media Editor variables for text editor
  editorMediaPhotoId;
  editorImgURL;

  // Product highlight variables
  productHighlightAmount = 4;
  productHighlights = [];

  // Data states
  activeContentTab: string = 'desc';
  productIsLoading = false;
  productIsSaving = false;
  mixtureIsSaving = false;
  productData: any = {};
  defaultQuantity = 0;
  maxQuantity = 0;
  reachMaxQty = false;
  enableAIAssistant = false;
  productUrl = '';
  featurePlan;
  storeUrlPrefix = '';

  setActiveContentTab(tab: string): void {
    this.activeContentTab = tab;
  }

  constructor(
    private svc: StoreService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private utils: UtilitiesService,
    private formBuilder: FormBuilder,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    console.log('ngOnInit');
    this.bearer = localStorage.getItem('bearer');
    this.storeId = localStorage.getItem('store_id');
    const dealerSubs = localStorage.getItem('dealer_subs');
    const info = JSON.parse(localStorage.getItem('5s-info'));

    const productId = this.activeRoute.snapshot.params.id;
    const langCode = this.activeRoute.snapshot.params.langCode ?? 'en-us';
    const countryCode = this.activeRoute.snapshot.params.countryCode;

    this.languageCode = langCode;
    this.countryCode = countryCode;
    this.productId = productId;

    this.getProductCustomInfo(productId,countryCode);
    this.getDealerPlan(info.d_id);
    this.getDealerCredit(info.d_id);
    this.getStoreUrlPrefix();
    this.dataService.setFromProductEdit(true);
  }

  getDealerPlan(dealerId) {
    if (this.dataService.getDealerPlan() === null) {
      this.svc.getDealerPlan(this.bearer, dealerId).subscribe((res) => {
        this.featurePlan = res['data']['feature_list'];
        this.dataService.updateDealerPlan(res['data']);
        this.dataService.updateDealerSubStatus(res['data']['dealer_subscription_status']);

        if (res['data']['feature_list'].includes('ai-assistant') || this.dataService.getDealerSubStatus() === false) {
          this.enableAIAssistant = true;
        }

      });
    } else {
      const dealerPlan = this.dataService.getDealerPlan();
      this.featurePlan = dealerPlan.feature_list;

      if (this.featurePlan.includes('ai-assistant') || this.dataService.getDealerSubStatus() === false) {
        this.enableAIAssistant = true;
      }
    }
  }

  getDealerCredit(dealerId) {
    this.svc.getDealerCredit(this.bearer, dealerId).subscribe(
      (res: any) => {
        this.enableAIAssistant = res.data.totalCredit >= res.data.minimumCredit && res.data?.is_valid === true;
      },
      (error) => {
        const errorMsg = this.utils.getErrorMessageWithRefId(
          error,
          'Unknown error, kindly contact our eStore team to check'
        );
        this.utils.notify.showError(errorMsg, 'Error!');
      }
    );
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');
  }

  initContentEditor() {
    let defaultButtons = $.trumbowyg.defaultOptions.btns;

    defaultButtons[3] = [
      'fontsize',
      'foreColor',
      'backColor',
    ];

    setTimeout(() => {
      $.trumbowyg.svgPath = '/library/trumbowyg-dist/ui/icons.svg';
      setTimeout(() => {
        $('.text-textarea').trumbowyg();
      }, 10);

      $('#product-overview.content-editor-textarea').trumbowyg({
        removeformatPasted: true,
        btns: [
          ['formatting'],
          ['strong', 'em', 'del'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['removeformat'],
        ],
      });

      $(
        '#product-desc.content-editor-textarea,#product-ingredient.content-editor-textarea,#product-direction.content-editor-textarea'
      ).trumbowyg({
        btns: defaultButtons,
      });
    }, 1000);
  }

  testMsgbox(event) {
    console.log(`test msgbox`, event);

    this.utils.msgBox.open({
      message: 'This is message box!',
      title: 'Test',
      icon: 'success',
    });
  }

  testRemoveToast(event) {}

  createCustomerProduct() {
    this.bearer = localStorage.getItem('bearer');
    console.log('token', this.bearer);
  }

  getMixtureProductByMixtureProductId(mixtureProductId) {
    let mixtureProducts = this.productData.mixture_data;
    return mixtureProducts?.find((mixtureProduct: any) => {
      return mixtureProduct.p_id == mixtureProductId;
    });
  }

  getProductCustomInfo(productId: Number, countryCode: string) {
    this.productIsLoading = true;
    this.mediaPhotoId = null; //reset value
    this.productData = {};

    const langCode = this.languageCode;

    this.svc
      .getProductCustomInfo(this.bearer, productId, langCode, countryCode)
      .subscribe((res) => {
        this.productIsLoading = false;
        let customData = res['data']['0'];
        if (customData === undefined) {
          // console.log('Product data not exist');
          // this.router.navigateByUrl('/dashboard/product-manager');
          return false;
        }
        this.productData = customData;
        // Generate default URL from product name if product_url doesn't exist or is empty
        if (this.productData.product_url && this.productData.product_url.trim() !== '') {
          this.productUrl = this.sanitizeProductUrl(this.productData.product_url);
        } else {
          this.productUrl = this.generateUrlFromProductName(this.productData.product_name);
        }
        this.defaultQuantity = this.productData.default_quantity;
        this.maxQuantity =
          this.productData.max_qty_per_order < 0
            ? 99
            : this.productData.max_qty_per_order;

        // Set product highlights
        if (customData.product_highlights?.length > 0) {
          this.productHighlights = customData.product_highlights;
        }

        if (typeof this.productData.metadata === 'undefined') {
          this.productData.metadata = {};
        }

        if (this.productData.ingredient) {
          const formattedList = this.productData.ingredient
            .map((itemArray) => `- ${itemArray[0]}<br>`)
            .join('\n');
          this.productData.ingredient = formattedList;
        }

        if (!this.productData.custom_ingredient) {
          this.productData.custom_ingredient = '';
        }

        if (!this.productData.direction) {
          this.productData.direction = '';
        }

        this.imgURL_Primary = customData?.primary_photo;
        const photoList = customData?.product_photo_list || [];
        photoList.forEach((url, i) => {
          this.imgURLs[i] = url || '';
        });

        console.log({ customData });
        this.initContentEditor();
      });
  }

  /*
  Image Upload for Trumbowyg content editor
  */
  lastInsertImageCallback: Function;
  handleTrumbowygMediaChanged(event) {
    console.log('handleTrumbowygMediaChanged', { event });
    this.lastInsertImageCallback(event.url);
  }

  handleSetInsertImageCallback(event) {
    console.log('handleSetInsertImageCallback', { event });
    this.lastInsertImageCallback = event.detail.InsertImageCallback;
  }

  saveCustomProduct(event) {
    const imgURLsToPush = [this.imgURLs[0], this.imgURLs[1], this.imgURLs[2]];

    imgURLsToPush.forEach((url, index) => {
      if (url !== null && url !== undefined) {
        if (this.imgURL_UploadImg.length > index) {
          this.imgURL_UploadImg[index] = url;
        } else {
          this.imgURL_UploadImg.push(url);
        }
      }
    });

    const {
      productId,
      storeId,
      languageCode,
      imgURL_Primary,
      imgURL_UploadImg,
      bearer,
      defaultQuantity,
      countryCode,
    } = this;
    this.productIsSaving = true;

    let productDesc = $(`#product-desc.content-editor-textarea`)[0].value;
    let productOverview = $(`#product-overview.content-editor-textarea`)[0]
      .value;

    let metadata = {
      page_title: this.productData['metadata']['page_title'],
      description: this.productData['metadata']['description'],
      keywords: this.productData['metadata']['keywords'],
    };

    let directionDesc = $(`#product-direction.content-editor-textarea`)[0]
      .value;

    let directionIngredient = $(
      `#product-ingredient.content-editor-textarea`
    )[0].value;

    let productUrl = this.sanitizeProductUrl(this.productUrl);

    let productHighlights = this.getValidProductHighlights();

    this.svc
      .updateProductCustom(
        storeId,
        productId,
        languageCode,
        this.productData['product_name'],
        productDesc,
        productOverview,
        imgURL_Primary,
        imgURL_UploadImg,
        metadata,
        directionDesc,
        directionIngredient,
        defaultQuantity,
        productHighlights,
        productUrl,
        countryCode,
        bearer
      )
      .subscribe(
        (data) => {
          console.log('Data Update Complete');
          this.utils.notify.showSuccess('Product details has been updated!');
        },
        (error) => {
          console.log(error);
          let errorMsg = error['error']['message'];
          console.error(errorMsg);
        },
        () => {
          this.productIsSaving = false;
        }
      );

    return;
  }

  saveMixtureProductNameChange(mixtureProductId, event) {
    const { productId, storeId, languageCode, imgURL_Primary, bearer } = this;
    this.mixtureIsSaving = true;

    let mixtureProduct =
      this.getMixtureProductByMixtureProductId(mixtureProductId);

    this.svc
      .updateProductMixtureInfo(
        storeId,
        mixtureProduct.p_id,
        languageCode,
        mixtureProduct.product_name,
        bearer
      )
      .subscribe(
        (data) => {
          this.utils.notify.showSuccess('Product mixture name has been updated!');
        },
        (error) => {
          console.log(error);
          let errorMsg = error['error']['message'];
          console.error(errorMsg);
        },
        () => {
          this.editMixtureProductId = null;
          this.mixtureIsSaving = false;
        }
      );

    return;
  }

  discardMixtureProductNameChange(productId, event = null) {
    let mixtureProduct = this.getMixtureProductByMixtureProductId(productId);

    // Revert product name to value from server.
    mixtureProduct.product_name = this.currentProductMixtureName;
    return (this.editMixtureProductId = null);
  }

  enableEditMixtureProduct(productId: Number, event?: any): void {
    const enableChange = () => {
      console.log(`Editing mixture product ${productId}`);
      this.editMixtureProductId = productId;
      let mixtureProduct = this.getMixtureProductByMixtureProductId(productId);
      if (mixtureProduct) {
        this.currentProductMixtureName = mixtureProduct.product_name || '';
      }

      if (event) {
        const targetElement = (event.currentTarget || event.target) as HTMLElement;
        const listElement = targetElement?.closest('.mixture-product-list');

        if (listElement) {
          const productNameInputElement: HTMLInputElement = listElement.querySelector(
            'input.mixture-product-name'
          );
          if (productNameInputElement) {
            this.currentProductMixtureName = productNameInputElement.value;
            setTimeout(() => productNameInputElement.focus(), 50);
          }
        }
      }
    };

    if (this.editMixtureProductId) {
      this.utils.msgBox.open({
        message: 'Discard mixture name change?',
        title: 'Discard?',
        icon: 'warning',
        buttonList: [
          {
            text: 'No',
          },
          {
            text: 'Discard',
            style: 'warning',
            onClick: () => {
              this.discardMixtureProductNameChange(this.editMixtureProductId);
              enableChange();
            },
          },
        ],
      });
    } else {
      enableChange();
    }
  }

  isEditMixtureProductName(productId: Number): boolean {
    return this.editMixtureProductId === productId;
  }

  minusQty() {
    if (this.defaultQuantity >= 2) {
      this.defaultQuantity -= 1;
      this.reachMaxQty = false;
    } else {
      this.defaultQuantity = 1;
      this.reachMaxQty = false;
    }
  }

  plusQty() {
    if (this.defaultQuantity >= this.maxQuantity) {
      this.reachMaxQty = true;
    } else {
      this.defaultQuantity += 1;
      this.reachMaxQty = false;
    }
  }

  filterOutEmptyProductHighlights() {
    const highlightInputs = this.getValidProductHighlights();
    this.productHighlights = highlightInputs;

    return highlightInputs;
  }

  getProductHighlightInputs() {
    let highlightInputs = this.productHighlights.filter(
      (item) => item !== null && item.trim() !== ''
    );

    if (highlightInputs.length < 1) {
      highlightInputs.push('');
    } else if (
      highlightInputs.length < this.productHighlightAmount &&
      highlightInputs[highlightInputs.length - 1].trim() !== ''
    ) {
      highlightInputs.push('');
    }

    return highlightInputs;
  }

  getValidProductHighlights() {
    let highlightInputs = this.productHighlights.filter(
      (item) => item !== null && item.trim() !== ''
    );

    return highlightInputs;
  }

  handleProductHighlightChange(event, i) {
    this.filterOutEmptyProductHighlights();

    const newValue = event.target.value;
    console.log('handleProductHighlightChange', { event, newValue, i });
    this.productHighlights[i] = newValue;

    event.target.value = '';
  }

  aiTextOutput = '';
  showAIContentGenerator(templateName, presetParams, changeCallback) {
    this.utils.aiContentGenerator.show(
      templateName,
      presetParams,
      (response) => {
        console.log('This is onChange', changeCallback, response);

        this[changeCallback] = response;
        console.log('changeCallback', this[changeCallback], { changeCallback });
      }
    );
    return templateName;
  }

  showAIProductSEOKeyword(presetParams) {
    this.utils.aiContentGenerator.show(
      'GENERATE_PRODUCT_PAGE_SEO_KEYWORD',
      presetParams,
      (response) => {
        this.productData.metadata.keywords = response;
      }
    );
  }

  showAIProductSEODesc(presetParams) {
    this.utils.aiContentGenerator.show(
      'GENERATE_PRODUCT_PAGE_SEO_DESC',
      presetParams,
      (response) => {
        this.productData.metadata.description = response;
      }
    );
  }

  showAIProductDesc(presetParams) {
    this.utils.aiContentGenerator.show(
      'GENERATE_PRODUCT_PAGE_DESC',
      presetParams,
      (response) => {
        this.productData.product_desc = response;
        $('#product-desc').trumbowyg('html', response);
      }
    );
  }

  generateUrlFromProductName(productName: string): string {
    if (!productName) {
      return '';
    }
    // Convert to lowercase, replace spaces with hyphens, and remove special characters
    // Allow: lowercase letters (a-z), numbers (0-9), hyphens (-), and Chinese characters (\u4e00-\u9fa5)
    return productName
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s\-\u4e00-\u9fa5]/g, '') // Remove special characters except allowed characters
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
      .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
  }

  onProductNameChange(productName: string): void {
    // Update productUrl when product name changes
    this.productUrl = this.generateUrlFromProductName(productName);
  }

  onProductUrlInput(event: any): void {
    // Filter input to only allow lowercase letters, numbers, hyphens, and Chinese characters
    const input = event.target.value;
    // Allow: lowercase letters (a-z), numbers (0-9), hyphens (-), and Chinese characters (\u4e00-\u9fa5)
    const sanitized = this.sanitizeProductUrl(input);
    // Update the model value
    this.productUrl = sanitized;
    // Update the input value directly to reflect the sanitized version
    if (input !== sanitized) {
      event.target.value = sanitized;
    }
  }

  sanitizeProductUrl(url: string): string {
    // Strip anything outside the allowed slug characters (e.g. stray newlines from stored data)
    return (url || '').replace(/[^a-z0-9\-一-龥]/g, '');
  }

  getStoreUrlPrefix(): void {
    if (this.storeId && this.bearer) {
      this.svc.getStoreInfo(this.bearer, this.storeId).subscribe(
        (res: any) => {
          const storeInfo = res.data;
          const storeSubdomain = environment.storeSubdomain || 'dev.fiv5s.dev';

          // Check if store_url is already a full URL
          if (storeInfo?.store_url && storeInfo.store_url.startsWith('http')) {
            this.storeUrlPrefix = `${storeInfo.store_url}/product/`;
          } else {
            // Construct full domain from subdomain + storeSubdomain (e.g., mystore.dev.fiv5s.dev)
            const subdomain = storeInfo?.subdomain || storeInfo?.store_url || '';
            if (subdomain) {
              // If subdomain already includes the domain suffix, use it as is
              // Otherwise, append the storeSubdomain
              const fullDomain = subdomain.includes('.')
                ? subdomain
                : `${subdomain}.${storeSubdomain}`;
              const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
              this.storeUrlPrefix = `${protocol}//${fullDomain}/product/`;
            } else {
              // Fallback: use current hostname
              const protocol = window.location.protocol;
              const hostname = window.location.hostname;
              this.storeUrlPrefix = `${protocol}//${hostname}/product/`;
            }
          }
        },
        (error) => {
          // Fallback: use current hostname if API call fails
          const protocol = window.location.protocol;
          const hostname = window.location.hostname;
          this.storeUrlPrefix = `${protocol}//${hostname}/product/`;
        }
      );
    } else {
      // Fallback: use current hostname
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      this.storeUrlPrefix = `${protocol}//${hostname}/product/`;
    }
  }
}
